var shim = {exports: {}};

export { shim as __module };
//# sourceMappingURL=index7.mjs.map
